// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"02b17548","119":"2b6c4859","587":"61bddc6a","654":"d121f213","767":"53e4c4c8","787":"f5b783fb"}[chunkId] + ".chunk.js";
};